const routes = [
    {
        path: '/documents',
        component: () => import('../pages/documents/Documents'),
        children: [
            {
                path: '',
                name: 'documents.index',
                component: () => import('../pages/documents/DocumentList'),
                meta: {
                    auth: true,
                    admin: true
                }
            },
            {
                path: 'create',
                name: 'documents.create',
                component: () => import('../pages/documents/DocumentForm'),
                props: {
                    title: 'creating_document'
                },
                meta: {
                    auth: true,
                    admin: true
                }
            },
            {
                path: ':id/edit',
                name: 'documents.edit',
                component: () => import('../pages/documents/DocumentForm'),
                props: {
                    title: 'editing_user',
                    edited: true
                },
                meta: {
                    auth: true,
                    admin: true
                }
            },
            {
                path: ':id/preview',
                name: 'documents.preview',
                component: () => import('../pages/documents/DocumentPreview'),
                meta: {
                    auth: true
                }
            }
        ]
    }
];

export default routes;
